import React, { useMemo } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { MarginProps } from '../../../../../theme/styledProps';
import { PortfolioGroupDTO } from '../../api/useMySettingsQuery';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../CommonComponents/OPL/Grid/Column';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { SettingsGrid } from '../../../FirmSettings/components/SettingsGrid/SettingsGrid';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { FormValues } from '../../MySettings.meta';
import { showFinancialPlanningSelector } from '../../../../../AdviserArea/AdviserAreaSelector';

interface Props extends MarginProps {
  groups: PortfolioGroupDTO[];
  formBag: UseFormReturn<FormValues>;
}

export const ModelGroup: React.FC<Props> = ({ formBag, groups, ...rest }) => {
  const showFinancialPlanning = useSelector(showFinancialPlanningSelector);

  const modelGroupOptions = useMemo(() => {
    return groups.map(({ name, id }) => ({
      label: name,
      value: id,
    }));
  }, [groups]);

  if (!showFinancialPlanning) {
    return null;
  }

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Model Portfolio Group" />

      <SettingsGrid>
        <Row>
          <Column width={4}>
            <Text variant="formLabel" mb="4">
              Default Group
            </Text>

            <Controller
              control={formBag.control}
              name="defaultPortfolioGroupId"
              render={({ field: { value } }) => (
                <Select
                  value={modelGroupOptions.find(({ value: _value }) => value === _value)}
                  options={modelGroupOptions}
                  onChange={opt => {
                    if (opt) {
                      formBag.setValue('defaultPortfolioGroupId', opt.value, { shouldDirty: true });
                    }
                  }}
                  placeholder="Select a default group"
                  aria-label="Select a default group"
                />
              )}
            />
          </Column>
        </Row>
      </SettingsGrid>
    </Box>
  );
};
